import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format'
// import Popover from '@dbk/ui-popover';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import { TrashCircle, Info2 } from '@dbk/ui-icons';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import Text,{H1} from '@dbk/ui-text';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import styles from './manage-devices.styles';
import { LoadingCircle } from '../../../components/common/loading';
import { TOAST_MESSAGE_TYPE, PALETTE } from '../../../constants';
import Popover from '@dbk/ui-popover';

class ManageDevices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      deviceCode: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { i18n: { messages }, vascoauthentication: { deactivateSecondFactorResponse } } = this.props;

    if (deactivateSecondFactorResponse !== prevProps.vascoauthentication.deactivateSecondFactorResponse && deactivateSecondFactorResponse !== null) {
      const result = deactivateSecondFactorResponse;

      const toastMsg = {};
      const orderIdMsg = {};
      if (result.returnCode === 0) {
        toastMsg.type = TOAST_MESSAGE_TYPE.CONFIRMATION;
        toastMsg.header = messages['app.profile.managedevice.successHeader'];
        orderIdMsg.errorDesc = <FormattedMessage
          id={'app.profile.managedevice.deleteActionSuccess'}
          defaultMessage={messages['app.profile.managedevice.deleteActionSuccess']}
        />
      } else {
        toastMsg.type = TOAST_MESSAGE_TYPE.ERROR;
        toastMsg.header = messages['app.profile.managedevice.errorHeader'];
        orderIdMsg.errorDesc = <FormattedMessage
          id={'app.profile.managedevice.deleteActionFailed'}
          defaultMessage={messages['app.profile.managedevice.deleteActionFailed']}
        />
      }
      const toastMessages = [];
      const msgs = [];
      msgs[0] = orderIdMsg
      toastMsg.message = msgs;
      toastMessages.push(toastMsg);
      this.props.setToastMsg(toastMessages);
    }
    if(this.state.showDeleteModal){
        if(document.querySelector('.modal__header-container')){
          document.querySelector('.modal__header-container').focus();
        }
    }
  }


  renderListItemHeaders = (messages) => (

    <div style={{ padding: '20px 20px 30px 20px' }}>

      <Text secondary tabIndex={0} className="columns small-2 medium-2 large-2" testID={`popover_manage_device_header_sno_test`}
        accessibilityLabel={`popover_manage_device_header_sno_test`}>
        {messages['app.profile.managedevice.sno']}
      </Text>

      <div className="columns small-4 medium-4 large-4 popover-icon-device" testID={`popover_manage_device_header_devicemodel_test`}
        accessibilityLabel={`popover_manage_device_header_devicemodel_test`}>
        <Text secondary tabIndex={0}>{messages['app.profile.managedevice.devicemodel']}</Text>
        {

          <Popover
            mode="popup"
            orientation="top"
            tabIndex={0}
            showOnHover
            testID={`popover_manage_device_model_test`}
            accessibilityLabel={`popover_manage_device_model_test`}
            popOverClassName="manage-details-action-content"
            arrowColor={PALETTE.secondaryActive}
            content={
                <div accessible={true}>{messages['app.profile.managedevice.devicePopoverText']}</div>
            }
          >
            <div aria-label={messages['app.profile.managedevice.devicemodel'] +" "+ messages['app.dashboard.toolTip'] +" "+ messages['app.profile.managedevice.devicePopoverText']}>
              <Info2 color={PALETTE.primaryText} />
            </div>
          </Popover>

        }
      </div>

      <div className="columns small-3 medium-3 large-3 popover-icon-device" testID={`popover_manage_device_header_deviceos_test`}
        accessibilityLabel={`popover_manage_device_header_deviceos_test`}>
        <Text secondary tabIndex={0}>{messages['app.profile.managedevice.deviceos']}</Text>
        {
          <Popover
            mode="popup"
            tabIndex={0}
            orientation="top"
            label={`popover_manage_device_header_deviceos_test`}
            // arrowColor={PALETTE.secondaryActive}
            showOnHover
            testID={`popover_manage_device_os_test`}
            accessibilityLabel={`popover_manage_device_os_test`}
            popOverClassName="manage-details-action-content"
            arrowColor={PALETTE.secondaryActive}
            content={        
                <div accessible={true}>{messages['app.profile.managedevice.devicePopoverText']}</div>
            }
          >
            <div aria-label={messages['app.profile.managedevice.deviceos'] +" "+ messages['app.dashboard.toolTip'] +" "+ messages['app.profile.managedevice.devicePopoverText']}>
              <Info2 color={PALETTE.primaryText} />
            </div>
          </Popover>

        }
      </div>

      <Text tabIndex={0} secondary className="columns small-2 medium-2 large-2" testID={`popover_manage_device_header_regDate_test`}
        accessibilityLabel={`popover_manage_device_header_regDate_test`}>
        {messages['app.profile.managedevice.regDate']}
      </Text>

      <div className="columns small-1 medium-1 large-1 text-right popover-icon-action" testID={`popover_manage_device_header_action_test`}
        accessibilityLabel={`popover_manage_device_header_action_test`}>
        <Text tabIndex={0} secondary>{messages['app.profile.managedevice.action']}</Text>
        {
          <Popover
            mode="popup"
            orientation="left"
            tabIndex={0}
            testID={`popover_manage_device_action_test`}
            accessibilityLabel={`popover_manage_device_action_test`}
            popOverClassName="manage-details-action"
            arrowColor={PALETTE.secondaryActive}
            content={
                <div>{messages['app.profile.managedevice.actionPopoverText']}</div>
            }
          >
            <div aria-label={messages['app.profile.managedevice.action'] +" "+ messages['app.dashboard.toolTip'] +" "+ messages['app.profile.managedevice.actionPopoverText']}>
              <Info2 color={PALETTE.primaryText}/>
            </div>
          </Popover>

        }
      </div>
    </div>
  )

  deviceListItem = (userDeviceDetails, messages, auth) => userDeviceDetails.map((item, idx) => (
    <NavigationList style={styles.navList}>
      <NavigationListItem style={styles.navListItem} hasArrow={false} tabIndex={-1}>

        <Text size="big" tabIndex={0} className="columns small-2 medium-2 large-2" testID={`text_manage_device_${item.deviceCode ? item.deviceCode : ''}_test`}
          accessibilityLabel={`text_manage_device_${item.deviceCode ? item.deviceCode : ''}_test`}>
          {idx + 1}
        </Text>

        <Text size="big" tabIndex={0} className="columns small-4 medium-4 large-4" testID={`text_manage_device_${item.deviceModel ? item.deviceModel : ''}_test`}
          accessibilityLabel={`text_manage_device_${item.deviceModel ? item.deviceModel : ''}_test`}>
          {item.deviceModel ? item.deviceModel : messages['app.profile.managedevice.nodevicedetails']}
        </Text>

        <Text size="big" tabIndex={0} className="columns small-3 medium-3 large-3" testID={`text_manage_device_${item.deviceOs ? item.deviceOs : ''}_test`}
          accessibilityLabel={`text_manage_device_${item.deviceOs ? item.deviceOs : ''}_test`}>
          {item.deviceOs ? item.deviceOs : messages['app.profile.managedevice.nodevicedetails']}
        </Text>

        <Text size="big" tabIndex={0} className="columns small-2 medium-2 large-2" testID={`text_manage_device_${item.regDate ? item.regDate : ''}_test`}
          accessibilityLabel={`text_manage_device_${item.regDate ? item.regDate : ''}_test`}>
          {item.regDate ? item.regDate : ''}
        </Text>

        <div className="columns small-1 medium-1 large-1 text-center" testID={`text_manage_device_delete_${item.deviceCode ? item.deviceCode : ''}_test`}
          accessibilityLabel={`text_manage_device_delete_${item.deviceCode ? item.deviceCode : ''}_test`}>
          <TouchableOpacity accessibilityLabel={messages['app.accessibility.settings.manageDevice.delete']} style={styles.iconStyle} disabled={auth.settingsDisabled} onPress={() => !auth.settingsDisabled ? this.onDeleteEntry(item.deviceCode, userDeviceDetails) : null}>
            <TrashCircle marginTop={22} marginRight={14} width={26} height={26} color={PALETTE.secondaryActive} />
          </TouchableOpacity>
        </div>

      </NavigationListItem>
    </NavigationList>
  ))

  onDeleteEntry = (deviceCode, userDeviceDetails) => {
    Object.keys(userDeviceDetails).length > 1 && this.setState({ showDeleteModal: true, deviceCode });
  }

  closeBlurModel = () => {
    this.setState({ showDeleteModal: false, deviceCode: '' });
  }

  deleteDeviceEntry = () => {
    this.props.deactivateDevice(this.state.deviceCode);
    this.setState({ showDeleteModal: false, deviceCode: '' });
  }


  render() {
    const { i18n: { messages }, vascoauthentication: { showSpinner, userDeviceDetails }, auth } = this.props;

    if (this.state.showDeleteModal) {
      return (<Modal
        isActive
        onClose={() => this.setState({ showDeleteModal: false })}
        header={messages['app.common.copyrightText']}
        content={
          <div className="deleteModal-modal" testID={`manage_device_modal_header_test`}
            accessibilityLabel={`manage_device_modal_header_test`}>
            <div tabIndex={0} className="manage-del-popup-desc">{messages['app.profile.managedevice.deleteMessage']}</div>
            <div className="deleteModal-modal__action">
              <div className="row">
                <div className="deletebtn deleteModal-modal__button-width">
                  <Button fullWidth onPress={this.deleteDeviceEntry}
                    testID={`manage_device_modal_yes_button_test`}
                    accessibilityLabel={`manage_device_modal_yes_button_test`}>
                    {messages['app.profile.managedevice.yesaction']}
                  </Button>
                </div>
                <div className="deletebtn deleteModal-modal__button-width">
                  <Button tertiary fullWidth onPress={this.closeBlurModel}
                    testID={`manage_device_modal_no_button_test`}
                    accessibilityLabel={`manage_device_modal_no_button_test`}>
                    {messages['app.profile.managedevice.noaction']}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        }
      />)
    }

    return (
      <div>
        <ScrollableLayout
          testID="Profile-view"
          body={
            <div className="padding-left-20 row consolidation">
              <div className="cloumns small-12 large-12 profile-container">

                <div id="title_manage-devices_page_title_test" className="profile-container__manage-device-title"
                  testID={`popover_text_manage_device_page_title_test`} accessibilityLabel={`popover_text_manage_device_page_title_test`}>
                  <H1 tabIndex={0}>{messages['app.common.pageTitle.manageDevice']}</H1>
                </div>

                {userDeviceDetails.length === 0 && !showSpinner ?
                  <div id="title_manage-devices_test" className="profile-container__title"
                    testID={`popover_text_manage_device_page_no_data_test`} accessibilityLabel={`popover_text_manage_device_page_no_data_test`}>
                    <Text size="large" tabIndex={0}>{messages['app.profile.managedevice.dataNotAvailable']}</Text>
                  </div>
                   : ''}

                {showSpinner ? <div className="manageDeviceSpinner"> <LoadingCircle /> </div> :
                  userDeviceDetails.length > 0 ? <div>
                    <div className="cloumns small-12 medium-12 large-12">
                      {this.renderListItemHeaders(messages)}
                    </div>
                    <div className="cloumns small-12 medium-12 large-12 settings-list">
                      {this.deviceListItem(userDeviceDetails, messages, auth)}
                    </div>
                  </div> : ''
                }
              </div>
            </ div>
          }
        />
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    vascoauthentication: {
      userDeviceDetails: true,
      showSpinner: true,
      deactivateSecondFactorResponse: true
    },
    deactivateDevice: { $call: 'vascoauthentication.deactivateSecondFactor' },
    setToastMsg: { $set: 'ui.toastMsg' },
    auth: {
      settingsDisabled: true
    }
  },
})(ManageDevices);
